import toMap from '~/misc/toMap';

export default toMap([
  'USER_FROMSTORAGE',
  'LOGIN',
  'LOGIN_FULL',
  'USER_DATA',
  'USER_VERIFY',
  'USER_W9FORM',
  'SIGNUP',
  'SIGNUPV2',
  'SIGNUP_FULL',
  'SET_TOKEN',

  'USER_UPLOAD_W9FORM',
  'USER_UPLOAD_INFO',
  'LOGOUT',
  'USER_RESET_ERROR',

  'RESET_PASSWORD',
  'CHANGE_PASSWORD',
  'USER_UPDATED',
  'USER_REPORTED_JOBTILE',

  'ACCOUNT_DATA',
  'USER_ACCOUNT_DATA',
  'HP_DATA',
  'CHANGE_PASSWORD_ASYNG_ERROR_HIDE',
  'GET_W9FORM_BY_EMAIL',

  'GET_DOTMC',

  'USER_SET_ALERT',
  'USER_SET_ALERT_POP',
  'USER_UPDATE_ALERT',
  'USER_UPDATE_ALERT_POP',
  'USER_SET_ALERT_DEFLUAT',
]);



// WEBPACK FOOTER //
// ./src/modules/user/types.js